module.exports = __webpack_public_path__ + "static/img/矩形@2x1.14d7ab8f.png";